import { Flex } from "antd";
import { FC, useMemo } from "react";
import { shallowEqual } from "react-redux";
import { formatUAHStandard } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import { PrimaryText } from "@/shared/ui/Typography";

import {
    DashboardCollapse,
    DashboardCollapseListItem,
} from "../components/DashboardCollapse";
import { DashboardErrorBlock } from "../components/DashboardErrorBlock";
import { SelectedDateSalaryState } from "../hooks/useSelectedDateSalary";
import { StyledSalaryAmount } from "./Styled";

interface SalaryProps {
    source: "manager" | "work";
    selectedDateSalary?: SelectedDateSalaryState;
}

export const Salary: FC<SalaryProps> = ({ source, selectedDateSalary }) => {
    const workState = useAppSelector(
        (state) => ({
            salary: state.work.salary,
            salaryError: state.work.salaryError,
        }),
        shallowEqual,
    );

    const managerState = useAppSelector(
        (state) => ({
            salary: state.manager.salary,
            salaryError: state.manager.salaryError,
        }),
        shallowEqual,
    );
    const stateVal = source === "manager" ? managerState : workState;

    const isCustomDateActive = selectedDateSalary?.isActive ?? false;
    const salary = isCustomDateActive
        ? selectedDateSalary?.salary
        : stateVal.salary;

    const salaryError = isCustomDateActive
        ? selectedDateSalary?.error
        : stateVal.salaryError;

    const salaryDetails: DashboardCollapseListItem[] = useMemo(
        () => [
            {
                label: "Ставка:",
                value: formatUAHStandard(salary?.amountRate ?? 0),
            },
            {
                label: "Бонуси:",
                value: formatUAHStandard(salary?.motivationBonus ?? 0),
            },
            {
                label: "Бонус від MML:",
                value: formatUAHStandard(salary?.mmlBonus ?? 0),
            },
        ],
        [salary],
    );

    if (!salaryError && !salary) return null;

    if (salaryError) {
        return <DashboardErrorBlock title={salaryError} />;
    }

    return (
        <DashboardCollapse
            header={
                <Flex
                    style={{ width: "100%" }}
                    justify="space-between"
                    align="center"
                >
                    <PrimaryText>До виплати:</PrimaryText>

                    <StyledSalaryAmount fontWeight="500" fontSize={16}>
                        {formatUAHStandard(salary?.total ?? 0)}
                    </StyledSalaryAmount>
                </Flex>
            }
            items={salaryDetails}
        />
    );
};
